<template>
  <div class="animated fadeIn">
    <div class="kt-portlet kt-portlet--mobile" style="position: relative">
      <div class="kt-portlet__body kt-portlet__body--fit" ref="cnt">
        <div class="m-4">
          <div class="filters-container">
            <TableFilters
              v-model="filterOptions"
              style="margin-right: 45px"
              @click="refresh"
            />
            <DropdownColumns
              :fields="[]"
              class="customize"
              :export-link2="exportLink"
              :export-json="exportJson"
              :print-link="printLink"
            />
          </div>
          <div style="overflow: auto" class="mt-2">
            <b-table
              id="operators-report-table"
              :busy.sync="isBusy"
              show-empty
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :hover="true"
              :striped="true"
              stacked="md"
              v-model="copy"
              :items="provider"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              @row-clicked="rowClicked"
              tbody-tr-class="tr-pointer"
            >
              <template v-slot:head(shop_code)="data">{{
                $t(data.label)
              }}</template>
              <template v-slot:head(shop_name)="data">{{
                $t(data.label)
              }}</template>
              <template v-slot:head(username)="data">{{
                $t(data.label)
              }}</template>
              <template v-slot:head(surname)="data">{{
                $t(data.label)
              }}</template>
              <template v-slot:head(name)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(income_bets)="data">{{
                $t(data.label)
              }}</template>
              <template v-slot:head(income_slots)="data">{{
                $t(data.label)
              }}</template>

              <template v-slot:cell(shop_code)="data">
                <span v-if="data.value">
                  <span v-if="data.value.to">
                    <router-link :to="`/shops/${data.value.to}`">{{
                      data.value.name
                    }}</router-link>
                  </span>
                  <span v-else>{{ data.value.name }}</span>
                </span>
              </template>

              <template v-slot:cell(shop_name)="data">
                <span v-if="data.value">
                  <span v-if="data.value.to">
                    <router-link :to="`/shops/${data.value.to}`">{{
                      data.value.name
                    }}</router-link>
                  </span>
                  <span v-else>{{ data.value.name }}</span>
                </span>
              </template>

              <template v-slot:cell(income_bets)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>
              <template v-slot:cell(income_slots)="data">
                <span v-if="data.value">{{ round(data.value) }}</span>
                <span v-else>0.00</span>
              </template>

              <template v-slot:empty="scope">
                <div class="text-center">{{ $t(scope.emptyText) }}</div>
              </template>
            </b-table>
          </div>
          <div class="container-fluid">
            <div class="row">
              <div style="white-space: nowrap" class="my-2">
                <PaginationSelect
                  v-model="perPage"
                  :options="paginationOpts"
                  variant="light"
                  size="sm"
                />
                <span>
                  &nbsp;
                  <i18n path="Showing {start}-{end} of {total} rows" tag="span">
                    <span slot="start">{{
                      (currentPage - 1) * perPage + 1
                    }}</span>
                    <span slot="end">{{ currentPage * perPage }}</span>
                    <span slot="total">{{ totalRows }}</span>
                  </i18n>
                </span>
                <b-button
                  size="sm"
                  @click.stop="
                    $root.$emit('bv::refresh::table', 'operators-report-table')
                  "
                  class="ml-2 refresh"
                  variant="light"
                  :title="$t('Refresh')"
                >
                  <i class="icon-refresh"></i>
                </b-button>
              </div>
              <nav class="ml-auto mt-2">
                <b-pagination
                  size="md"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                />
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { errorConf } from "@/shared/notifications";
import tableMixin from "@/shared/mixins/table.mixin";
import PaginationSelect from "@/components/PaginationSelect";
import DropdownColumns from "@/components/DropdownColumns";
import TableFilters from "@/components/TableFilters";
import timeFormat from "@/shared/timeFormat";

export default {
  name: "operatorsReport",
  mixins: [tableMixin],
  components: {
    PaginationSelect,
    DropdownColumns,
    TableFilters,
  },
  data: function () {
    return {
      tableName: "operatorsReport",
      filterOptions: [
        {
          field: "company_id",
          multiple: true,
          placeholder: "Company",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "companies",
          hide_select: true,
          filterOptions: ["tenant_id"],
          options: [],
          selected: [],
        },
        {
          field: "tenant_id",
          multiple: true,
          placeholder: "Tenant",
          trackBy: "eid",
          label: "brand_name",
          translate: false,
          store: "tenants",
          hide_select: true,
          filterOptions: ["shopgroup_id", "shop_id"],
          options: [],
          originalOptions: [],
          selected: [],
          postIgnore: true,
          filterOptionsBy: (data, field, fieldValue) => {
            const selected = fieldValue.map((elem) => elem.eid);
            const orig = data.list[1].originalOptions;
            if (
              selected.length == 0 &&
              data.list[1].options.length != orig.length
            ) {
              data.list[1].options = orig;
            } else if (selected.length != 0) {
              data.list[1].options = orig.filter((item) => {
                if (selected.indexOf(item.ecompany_id) > -1) {
                  return true;
                }
                return false;
              });
            }
          },
        },

        {
          field: "shopgroup_id",
          multiple: true,
          placeholder: "Shop Group",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "shopGroups",
          hide_select: true,
          options: [],
          originalOptions: [],
          selected: [],
          filterOptions: ["shop_id"],
          postIgnore: true,
          filterOptionsBy: (data, field, fieldValue) => {
            const selected = fieldValue.map((elem) => elem.eid);
            const index = 2;
            const orig = data.list[index].originalOptions;
            if (selected.length == 0) {
              data.list[index].options = orig;
            } else {
              data.list[index].options = orig.filter((item) => {
                if (selected.indexOf(item.etenant_id) > -1) {
                  return true;
                }
                return false;
              });
            }
          },
        },
        {
          field: "shop_id",
          multiple: false,
          placeholder: "Shop",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "shops",

          options: [],
          originalOptions: [],
          selected: [],
          filterOptionsBy: (data, field, fieldValue) => {
            let selectedTenants = [];
            let selectedShopGroups = [];

            if (field == "tenant_id") {
              selectedTenants = fieldValue.map((elem) => elem.eid);
            } else {
              selectedTenants = data.list[0].selected.map((elem) => elem.eid);
            }
            if (field == "shopgroup_id") {
              selectedShopGroups = fieldValue.map((elem) => elem.eshop_ids);
              if (selectedShopGroups.length) {
                selectedShopGroups = [].concat.apply([], selectedShopGroups);
              }
            } else {
              selectedShopGroups = data.list[2].selected.map(
                (elem) => elem.eshop_ids
              );
              if (selectedShopGroups.length) {
                selectedShopGroups = [].concat.apply([], selectedShopGroups);
              }
            }
            const index = 3;
            const orig = data.list[index].originalOptions;

            if (!selectedTenants.length && !selectedShopGroups.length) {
              data.list[index].options = orig;
            } else {
              let tmp = [];

              if (selectedTenants.length) {
                tmp = orig.filter((item) => {
                  if (selectedTenants.indexOf(item.etenant_id) > -1) {
                    return true;
                  }
                  return false;
                });
              }

              if (selectedShopGroups.length) {
                if (!selectedTenants.length && !selectedTenants.length) {
                  tmp = orig;
                }
                tmp = tmp.filter((item) => {
                  if (selectedShopGroups.indexOf(item.eid) > -1) {
                    return true;
                  }
                  return false;
                });
              }
              data.list[index].options = tmp;
            }
          },
        },
        {
          field: "save_time",
          type: "date",
          opens: "right",
          showDropdowns: true,
          selected: {
            startDate: moment(),
            endDate: moment(),
          },
          default: {
            startDate: moment(),
            endDate: moment(),
          },
          singleDatePicker: true,
          timePicker: false,
          locale: {
            format: timeFormat.datePickerShort, //format of the dates displayed
            firstDay: 1, //ISO first day of week - see moment documenations for details
            showWeekNumbers: true, //show week numbers on each row of the calendar
          },
          ranges: false,
        },
      ],
      isBusy: false,
      sortBy: "",
      sortDesc: true,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      filterField: null,
      checkAll: false,
      copy: null,
      addLabel: "",
    };
  },
  computed: {
    fields() {
      const columns = [
        {
          key: "shop_code",
          label: "Shop Code",
          sortable: false,
          ignore: true,
          class: "",
        },
        {
          key: "shop_name",
          label: "Shop Name",
          sortable: false,
          ignore: true,
          class: "",
        },
        {
          key: "username",
          label: "Username",
          sortable: false,
          ignore: false,
          class: "",
        },
        {
          key: "surname",
          label: "Surname",
          sortable: false,
          ignore: true,
          class: "",
        },
        {
          key: "name",
          label: "Name",
          sortable: false,
          ignore: true,
          class: "",
        },
        {
          key: "income_bets",
          label: "Betting Income",
          sortable: false,
          ignore: true,
          class: "",
        },
        {
          key: "income_slots",
          label: "Slot Income",
          sortable: false,
          ignore: true,
          class: "",
        },
      ];
      return columns;
    },
    lang() {
      return this.$store.getters["global/defLanguage"];
    },
    exportLink() {
      const apiUrl = this.$store.getters["global/apiUrl"];
      const endpoint = this.$store.getters["operatorsReport/endpoint"];

      return `${apiUrl}/${endpoint}?export=xls&lang=${this.lang}`;
    },
    printLink() {
      return "/print/operators-report";
    },
    exportJson() {
      const fields = [];
      this.fields.forEach((item) => {
        if (
          typeof item.class != "undefined" &&
          item.class.indexOf("d-none") == -1
        ) {
          let key = item.key;
          if (key != "selected") {
            const efields = ["eshop_id"];

            if (efields.indexOf(key) > -1) {
              key = key.substr(1);
            }

            fields.push(key);
          }
        }
      });

      const paginationData = this.buildPagination().body;

      paginationData.fields = fields;

      return JSON.stringify(paginationData);
    },
  },
  methods: {
    refresh() {
      this.$root.$emit("bv::refresh::table", "operators-report-table");
    },
    provider(ctx, callback) {
      const loading = this.$loading.open({
        container: this.$refs.cnt,
      });

      const paginationData = this.buildPagination();

      const shopByID = this.$store.getters["cache/shopByID"];
      const operatorByID = this.$store.getters["cache/operatorByID"];

      Promise.all([
        this.$store.dispatch("cache/fetch", "shops").catch((e) => e),
        this.$store.dispatch("cache/fetch", "operators").catch((e) => e),
      ]).finally(() => {
        this.$store
          .dispatch("operatorsReport/fetch", paginationData)
          .then((resp) => {
            this.totalRows = resp.data.total;
            resp.data.rows.forEach((item, index) => {
              if (item.eshop_id) {
                item.shop_name = {
                  to: item.eshop_id,
                  name: item.shop_name,
                };
                item.shop_code = {
                  to: item.eshop_id,
                  name: item.shop_code,
                };
              }

              if (item.euser_id) {
                const data = operatorByID(item.euser_id);
                if (data) {
                  item.user_id = {
                    to: item.euser_id,
                    name: data.full_name,
                  };
                } else {
                  item.user_id = {
                    to: null,
                    name: item.euser_id,
                  };
                }
              }
            });
            callback(resp.data.rows);
          })
          .catch((err) => {
            this.$bvToast.toast(
              this.$t(
                err.details && err.details.length ? err.details[0] : err.message
              ),
              errorConf(this.$t("Error"))
            );
            this.totalRows = 0;
            callback([]);
          })
          .finally(() => {
            loading.close();
          });
      });

      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },
    buildPagination() {
      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage,
      };

      if (this.filter && this.filterField) {
        paginationData.likeValues = [this.filter];
        paginationData.likeFields = [this.filterField];
      } else {
        paginationData.likeValues = [];
        paginationData.likeFields = [];
      }

      if (this.sortBy) {
        paginationData.sortBy = [this.sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];
      }

      const exactFields = [];
      const exactValues = [];

      this.filterOptions.forEach((item) => {
        if (item.type != "date" && item.selected.length && !item.postIgnore) {
          exactFields.push(item.field);
          if (item.trackBy) {
            const tmp = [];
            item.selected.forEach((el) => {
              tmp.push(el[item.trackBy]);
            });
            exactValues.push(tmp);
          } else {
            exactValues.push(item.selected);
          }
        } else if (item.type == "date") {
          if (item.selected.startDate && item.selected.endDate) {
            paginationData.dateField = item.field;
            paginationData.dateStart = item.selected.startDate;
            paginationData.dateEnd = item.selected.endDate;
          } else {
            paginationData.dateField = item.field;
            paginationData.dateStart = moment().startOf("day");
            paginationData.dateEnd = moment().endOf("day");
          }
        }
      });

      if (exactFields.length) {
        paginationData.exactFields = exactFields;
        paginationData.exactValues = exactValues;
      }

      return { body: paginationData };
    },
    rowClicked(item, index, event) {},
    redirect() {},
  },
};
</script>

<style lang="scss" scoped>
::v-deep #operators-report-table th:nth-child(n + 3) {
  text-align: right;
}
::v-deep #operators-report-table td:nth-child(n + 3) {
  text-align: right;
}
</style>
